<div class="no-content">
    <p>{{ content }}</p>
</div>
